import type { ComponentProps, ReactNode } from 'react';

import { TableHeader, cn } from '@workspace/shadcn';

export function StickyTableBox({ children }: { children: ReactNode }) {
  return (
    <div className="bg-card flex min-h-0 flex-1 overflow-hidden rounded-md border">
      {children}
    </div>
  );
}

export function StickyTableHeader({
  className,
  ...props
}: ComponentProps<typeof TableHeader>) {
  return (
    <TableHeader
      className={cn(
        'bg-card [&_th]:bg-card [&_th]:shadow-[inset_0_-1px_0_0_var(--border)] sticky top-0 z-10',
        className,
      )}
      {...props}
    />
  );
}
